import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { ReportTypeUpdateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { InputText } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type ReportTypeUpdateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  name: string;
  nameSelectedValue?: { displayId: string; id: string } | null;
  onNameChange?: (value: string) => void;
  nameError?: string;
  description: string;
  descriptionSelectedValue?: { displayId: string; id: string } | null;
  onDescriptionChange?: (value: string) => void;
  descriptionError?: string;
  reportTypeUpdateStore: ReportTypeUpdateStore;
};

export const ReportTypeUpdateForm: React.FC<ReportTypeUpdateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      name = "",
      nameError,
      onNameChange = () => {},
      description = "",
      descriptionError,
      onDescriptionChange = () => {},
      reportTypeUpdateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelUpdatedEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="ReportType"
              mode="update"
              values={{}}
              options={{}}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "name":
                    onNameChange?.(valor);
                    break;
                  case "description":
                    onDescriptionChange?.(valor);
                    break;
                }
              }}
            />
            <GroupContainer
              id="null"
              errorText={reportTypeUpdateStore.getCardErrors("null")}
              title={langStore.groupReportTypeLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <InputString
                  autoFocus
                  value={name}
                  error={Boolean(nameError)}
                  warning={
                    !nameError &&
                    Boolean(reportTypeUpdateStore.warnings["name"])
                  }
                  helperText={
                    nameError || reportTypeUpdateStore.warnings["name"]?.message
                  }
                  label={langStore.ReportTypeNameLabel}
                  onChange={(value: string) => onNameChange(value)}
                  description={langStore.ReportTypeNameDescription}
                />
                <InputText
                  value={description}
                  error={Boolean(descriptionError)}
                  warning={
                    !descriptionError &&
                    Boolean(reportTypeUpdateStore.warnings["description"])
                  }
                  helperText={
                    descriptionError ||
                    reportTypeUpdateStore.warnings["description"]?.message
                  }
                  label={langStore.ReportTypeDescriptionLabel}
                  onChange={(value: string) => onDescriptionChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.ReportTypeDescriptionDescription}
                />
              </FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
